// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"525266b3","977":"027b8683"}[chunkId] + ".chunk.js";
};